<template>
	<div class="containBox">
		<div>
			<NavMenu/>
		</div>
		<div class="homewarp typeArae">
			<div class="homecarouselBox">
				<div class="carouselBox">
					<el-carousel trigger="click" height="388px" :interval='6000'>
						<el-carousel-item v-for="(item,index) in swipeData" :key="index">
							<img :src='srcUrl+item.titleImgUrl' v-if="item.titleImgUrl" @click="goNewsDetailFn(item)" />
							<div class="titleBox ">
								<div class="title overflowone">
									{{item.pressTopic}}
								</div>
							</div>
						</el-carousel-item>

					</el-carousel>
				</div>
				<!-- <div class="informBox">
					<div class="commonTabsStyleBox">
						<div class="tabbox">
							<div v-for="(item,index) in newsTitle" :key="index" :class="activeNewName==item.name?'activetabNamebox':'tabNamebox'" @click="checknewsTab(item)">
								<span> {{item.name}}</span>
							</div>
						</div>
						<span class="morebox" @click="gosecondFn(item)">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="titleDateBox" v-if="newsData.length!==0">
						<div v-for="(item,index) in newsData" :key="index" class="newitemBox" @click="goNewsDetailFn(item)">
							<div class="title overflowone">{{item.pressTopic}}</div>
							<div class="time">{{item.pressTime | timer}}</div>
						</div>
					</div>
					<div class="emptyBox" v-else>
						<img src="@/assets/imgs/home/emptyimg.png" />
					</div>
				</div> -->
				<div class="informBox">
					<div class="leftMenuBox">
						<div class="jumpMenuBox">
							<img v-for="(item,i) in jumpList" :src="item.img" :key="i" @click="linkFn(item)" class="menuImg">
						</div>
					</div>
					<div class="searchBox">
						<div class="commonTabsStyleBox commonHomeborder">
							<div class="tabbox">
								<span class="line"></span>
								<span class="name">信息查询</span>
							</div>
						</div>
						<div class="cardsearch">
							<div v-for="(item,i) in searchData" :key="i" class="itemBox" @click="linkTarin(item)">
								<img class="imgbox" :src="item.img" />
								<div class="namebox">{{item.name}}</div>
							</div>
						</div>
					</div>
					<!-- <div class="infoSearchBox">
						<div v-for="(item,i) in searchList" :key="i" class="searchTextBox" @click="changeSearch(item.name)">
							<span :class="currentSearch==item.name?'activesearchItem':'searchItem'">{{item.name}}</span>
						</div>
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="formwarp">
						<el-form-item label="姓名" prop="names">
							<el-input v-model="ruleForm.names" @blur="nameBlur"></el-input>
						</el-form-item>
						<el-form-item label="身份证号码" prop="cardCode">
							<el-input v-model="ruleForm.cardCode" style="width:335px" @blur="cardCodeBlur"></el-input>
						</el-form-item>
						<div @click="submitForm('ruleForm')" :class="cardCodeVal&&nameVal?'searchbtnBox searchbtn':'searchbtnBox'">查询</div>
					</el-form>
					<el-dialog :title="currentSearch" :visible.sync="infoVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
					    :close-on-click-modal='false' :append-to-body="true">
						<div class="singupdialogcenter">
							<el-form :model="ruleForm" ref="ruleForm" :rules="rules">
								<el-row :gutter="20">
									<el-col :span="8">
										<el-form-item label="姓名:" prop="names" label-width="60px">
											<el-input v-model="ruleForm.names"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="10">
										<el-form-item label="身份证号码:" prop="cardCode" label-width="120px">
											<el-input v-model="ruleForm.cardCode"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<div class="submintBtn" @click="submitForm('ruleForm')">立即查询</div>
									</el-col>
								</el-row>
							</el-form>
							<div class="datawarp">
								<div class="searchbox">
									<div v-for="(item,index) in searchList" :key="index" :class="currentSearch==item.name?'activesearchItem':'searchItem'" @click="dialogSearchFn(item)">
										{{item.name}}
									</div>
								</div>
								<div v-if="currentSearch=='报名信息查询'">
									<div v-if="infoDataList.length!=0">
										<div class="datalistBox">
											<div class="trainItem" v-for="(item,index) in infoDataList" :key="index">
												<div class="name overflowone">{{item.trainCourse}}</div>
												<div class="courseinfobox">
													<div>课程编码：
														<span>{{item.trainCode}}</span>
													</div>
													<div class="overflowone">培训费用：
														<span>{{item.pay}}</span>
													</div>
													<div>招报人数：
														<span>{{item.playNumber}}</span>
													</div>
													<div>报名截止：
														<span class="deadlinebox">{{item.deadline}}</span>
													</div>
												</div>
												<div class="registeredbox" v-if="item.audit==0">
													已报名
												</div>
												<div class="registeredbox" v-if="item.audit==1">
													初审合格
												</div>
												<div class="registeredbox" v-if="item.audit==2">
													审核通过
												</div>
												<div class="registeredbox" v-if="item.audit==3">
													审核未通过
												</div>
												<div class="registeredbox" v-if="item.audit==4">
													培训完成
												</div>
											</div>
										</div>
										<div style="textAlign:center">
											<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
											    :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
											</el-pagination>
										</div>
									</div>
									<div v-else class="searchempty">
										<img src="@/assets/imgs/train/img1.png" />
									</div>
								</div>
								<div v-if="currentSearch=='成绩证书查询'">
									<div v-if="certificateList.length!=0">
										<div class="pdfdatabox">
											<div class="pdfItem" v-for="(item,index) in certificateList" :key="index">
												<div class="pdftop">
													<div class="certificateName" v-if="item.certificateName">证书名称：{{item.certificateName}}</div>
													<div v-if="item.certificateCode">证书编号：{{item.certificateCode}}</div>
												</div>
												<div class="pdfbotbox">
													<div class="downbox" v-if="item.certificateUrl" @click="downloadFn(item.certificateUrl)">
														<img src="@/assets/imgs/train/bgimg2.png" />
														<span class="downicon">
															<i class="el-icon-download icon" />
														</span>
													</div>
													<div class="courseinfobox">
														<div class="name overflowone">{{item.trainCourse}}</div>
														<div class="infotext">姓名：
															<span>{{ruleForm.names}}</span>
														</div>
														<div class="infotext">身份证号码：
															<span>{{ruleForm.cardCode}}</span>
														</div>
														<div class="infotext ">成绩：
															<span class="score">{{item.score}}</span>
														</div>
														<div class="infotext" v-if="item.certificateUrl">发证时间：
															<span class="deadlinebox">{{item.creationTime | timer}}</span>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div style="textAlign:center">
											<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
											    :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="certificatetotal">
											</el-pagination>
										</div>
									</div>
									<div v-else class="searchempty">
										<img src="@/assets/imgs/train/img1.png" />
									</div>
								</div>
							</div>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="offmodalFn">关闭</el-button>
						</span>
					</el-dialog> -->
				</div>

			</div>
			<div class="secondhomeNewsBox">
				<div class="leftnewBox">
					<div class="commonTabsStyleBox">
						<div class="tabbox">
							<div v-for="(item,index) in newsTitleData2" :key="index" :class="activeNewName2==item.name?'activetabNamebox':'tabNamebox'"
							    @click="checknewsTab2(item)">
								<span> {{item.name}}</span>
							</div>
						</div>
						<span class="morebox" @click="gosecondFn1(item)">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<!-- <div v-if="activeNewName2=='会议活动'">
						<div class="titleDateBox" v-if="confereeData.length!==0">
							<div v-for="(item,index) in confereeData" :key="index" class="newitemBox" @click="goconfereeDetailFn(item)">
								<div class="title overflowone">{{item.confereeName}}</div>
								<div class="time">{{item.creationTime | timer}}</div>
							</div>
						</div>
						<div class="emptyBox" v-else>
							<img src="@/assets/imgs/home/emptyimg.png" />

						</div>
					</div> -->
					<div>
						<div class="titleDateBox" v-if="newsData2.length!==0">
							<div v-for="(item,index) in newsData2" :key="index" class="newitemBox" @click="goNewsDetailFn(item)">
								<div class="title overflowone">{{item.pressTopic}}</div>
								<div class="time">{{item.pressTime | timer}}</div>
							</div>
						</div>
						<div class="emptyBox" v-else>
							<img src="@/assets/imgs/home/emptyimg.png" />

						</div>
					</div>
				</div>
				<div class="rightnewBox">
					<div class="commonTabsStyleBox commonHomeborder">
						<div class="tabbox">
							<!-- <div v-for="(item,index) in memberTitle" :key="index" :class="memberName==item.name?'activetabNamebox':'tabNamebox'" @click="checknewsTab2(item)">
								<span> {{item.name}}</span>
							</div> -->
							<span class="line"></span>
							<span class="name">会员风采</span>
						</div>
						<span class="morebox" @click="gosecondFn2">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="groupCulture-box" v-if="vipData.length!==0">
						<div v-for="(item, index) in vipData" :key="index" class="business-imgbox" @click="goNewsDetailFn(item)">
							<img :src="srcUrl+item.titleImgUrl" class="business-img" />
							<div class="title overflowtwo">{{item.pressTopic}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="ContactUsbox">
				<div class="contactusItem">
					<div class="rightblockbox">
						<div class="iconbox">
							<!-- <img src="@/assets/imgs/home/phone.png" class="iconimg" /> -->
							<div class="iconimg1 imgbox"></div>
							<!-- <div class="infobox2">联系电话</div> -->
						</div>
						<!-- <div class="triangle"></div> -->
						<div class="leftnonebox">
							<!-- <div>办公室：010-88824565</div>
							<div>发展部：010-88824569</div>
							<div>会员部：010-68709272</div> -->
							<div>
								<div>联系电话及传真</div>
								<div>
									010-68771390
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="contactusItem">
					<div class="rightblockbox">
						<div class="iconbox">
							<!-- <img src="@/assets/imgs/home/site.png" class="iconimg" /> -->
							<div class="iconimg2 imgbox"></div>
							<!-- <div class="infobox2">联系地址</div> -->
						</div>
						<!-- <div class="triangle"></div> -->
						<div class="leftnonebox">
							<div><img src="@/assets/imgs/home/smallsite.png" />北京市朝阳区西大望路15号4号楼9层</div>
						</div>
					</div>
				</div>
				<div class="contactusItem">
					<div class="rightblockbox">
						<div class="iconbox">
							<!-- <img src="@/assets/imgs/home/email.png" class="iconimg" /> -->
							<div class="iconimg3 imgbox"></div>
							<!-- <div class="infobox2">意见邮箱</div> -->
						</div>
						<!-- <div class="triangle"></div> -->
						<div class="leftnonebox">
							<div>
								<img src="@/assets/imgs/home/smallemail.png" /> xhmsc@zgrcjlxh.com
							</div>
						</div>
					</div>
				</div>
				<div class="contactusItem">
					<div class="rightblockbox">
						<div class="iconbox">
							<!-- <img src="@/assets/imgs/home/unit.png" class="iconimg" /> -->
							<div class="iconimg4 imgbox"></div>
							<!-- <div class="infobox2-4">公众号</div> -->
						</div>
						<!-- <div class="triangle"></div> -->
						<div class="leftnonebox">
							<div class="infobox3">中国人才交流协会</div>
							<img src="@/assets/imgs/home/wechart.png" />
						</div>
					</div>
				</div>
				<div class="contactusItem">
					<div class="rightblockbox" @click="gohelpFn">
						<div class="iconbox">
							<div class="iconimg5 imgbox"></div>
							<!-- <img src="@/assets/imgs/home/help.png" class="iconimg" /> -->
							<!-- <div class="infobox2">帮助中心</div> -->
						</div>
						<div class="leftnonebox">
							<div>帮助中心</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footerbox">
			<Footer/>
		</div>
		<!-- 完善用户信息 -->
		<WechartUserModal v-if="!iswechatUpdate" @offWechartModal='offWechartModal' />
	</div>

</template>

<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import WechartUserModal from './WechartUserModal'
import { httpService, srcUrl } from "@/service/httpService";
import { log } from 'util';
export default {
	name: "Home",
	components: {
		NavMenu,
		Footer,
		WechartUserModal
	},
	data() {
		return {
			testDataList: [],
			newsData: [],
			newsData2: [],
			vipData: [],
			swipeData: [],
			newswipeList: [],
			srcUrl: srcUrl,
			// newsTitle: [
			// 	{ 'name': '时政要闻', url: '' },
			// 	{ 'name': '行业动态', url: '' },
			// 	// { 'name': '协会动态' },
			// ],
			newsTitleData2: [
				{ 'name': '通知公告', url: '/news-secondpage/notice' },
				{ 'name': '时政要闻', url: '/news-secondpage/politics' },
				{ 'name': '行业动态', url: '/news-secondpage/industry-dynamics' },
			],
			memberTitle: [
				{ 'name': '会员风采', url: '/member-secondpage/member-style' },
			],
			memberName: '会员风采',
			// activeNewName: '时政要闻',
			activeNewName2: '通知公告',
			trainData: [],
			searchList: [
				{ name: '报名信息查询' },
				{ name: '成绩证书查询' },
			],
			currentSearch: '报名信息查询',
			ruleForm: {
				names: '',
				cardCode: '',
			},
			rules: {
				names: [
					{ required: true, message: '姓名', trigger: 'blur' },
				],
				cardCode: [
					{ required: true, message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
				],
			},
			currentPage: 1,
			pageSize: 10,
			total: null,
			certificateList: [],
			infoDataList: [],
			certificatetotal: null,
			CourseData: [],
			confereeData: [],
			// 判断是否登录
			token: sessionStorage.getItem('token'),
			audit: sessionStorage.getItem('audit'),
			singupVisible: false,//课程报名
			tarinSearchVisible: false,//课程查询
			currentCourse: null,
			jumpList: [
				{ name: '申请入会', img: require("@/assets/imgs/home/sidebar/iocn6.png"), url: '/account-center/member-ship' },
				{ name: '能力指数测评', img: require("@/assets/imgs/home/sidebar/iocn7.png"), url: '/assessment-institutions' },
				{ name: '培训服务', img: require("@/assets/imgs/home/sidebar/iocn8.png"), url: '/train-service' },
				{ name: '会议活动', img: require("@/assets/imgs/home/sidebar/iocn9.png"), url: '/meet-secondpage/meetactive' },
			],
			searchData: [
				{ name: '报名信息查询', img: require("@/assets/imgs/home/sidebar/iocn10.png"), url: '/train-service' },
				{ name: '成绩证书查询', img: require("@/assets/imgs/home/sidebar/iocn11.png"), url: '/train-service' },
			],
			infoVisible: false,
			timeMerber: null,
			memberPagecurrent: 1,
			memberPages: '',
			mermberTotal: '',
			cardCodeVal: '',
			nameVal: '',
			iswechatUpdate: true,
		};
	},
	created() {
		if (this.$route.query.code) {
			this.userCode()
		}
		// this.getTest()
		// this.getNews(22)
		this.getVipList()
		this.getSwipes()
		// this.getTrainlist()
		this.getNewsfn(16)
		// this.getCourseListFn()
		// this.getconfereeListFn()
		// this.weChatUpdate(1515)//记得取消
	
		if (JSON.parse(sessionStorage.getItem('userInfo'))) {
			let userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
			if (userId) {
				// 判断微信登录是否修改用户名
				this.weChatUpdate(userId)
			}
		}
	},
	mounted() {
		this.timeMerber = window.setInterval(() => {
			this.memberPagecurrent++
			if (this.mermberTotal / 2 == 0) {
				if (this.memberPages < this.memberPagecurrent) {
					this.memberPagecurrent = 1
				}
			} else {
				if (this.memberPages - this.memberPagecurrent === 0) {
					this.memberPagecurrent = 1
				}
			}
			this.getVipList()
		}, 10000)
	},
	beforeDestroy() {
		clearInterval(this.timeMerber);
		this.timeMerber = null
		this.memberPagecurrent = 1
	},
	methods: {
		userCode() {
			httpService.LoginAndRegister(this.$route.query.code).then(res => {
				if (res.code == 200) {
					let data = res.result
					sessionStorage.setItem('clickMenu', '首页')
					sessionStorage.setItem('token', data.token)
					sessionStorage.setItem('userInfo', JSON.stringify(data.principal.loginVo))
					this.$router.push('/');
					this.$router.go(0)
					this.weChatUpdate(data.principal.loginVo.userId)
				} else {
					this.$message.error(res.message);
				}
			})
		},
		weChatUpdate(userId) {
			httpService.isUpdateUserName(userId).then(res => {
				if (res.code == 200) {
					this.iswechatUpdate = res.result
				}
			})
		},
		offWechartModal() {
			this.iswechatUpdate = true
		},
		// async getTest() {
		// 	let params = {
		// 		pageSize: 4,
		// 		pageCurrent: 1,
		// 		pressSuperClass: "16",
		// 	};
		// 	let data = await httpService.getNewsList(params);
		// 	if (data.code == 200) {
		// 		this.testDataList = data.result.list
		// 	}
		// },
		// async getNews(val) {
		// 	let params = {
		// 		pageSize: 6,
		// 		pageCurrent: 1,
		// 		pressSuperClass: val,
		// 	};
		// 	let data = await httpService.getNewsList(params);
		// 	if (data.code == 200) {
		// 		this.newsData = data.result.list
		// 	}
		// },
		async getNewsfn(val) {
			let params = {
				pageSize: 6,
				pageCurrent: 1,
				pressSuperClass: val,
				audit:1,
                status:1
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsData2 = data.result.list
			}
		},
		async getSwipes() {
			let data = await httpService.getSwipeList();
			if (data.code == 200) {
				this.swipeData = data.result
			}
		},
		async getVipList() {
			let params = {
				pageSize: 2,
				pageCurrent: this.memberPagecurrent,
				pressSuperClass: "4",
				audit:1,
                status:1
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.vipData = data.result.list
				this.memberPages = data.result.pages
				this.mermberTotal = data.result.total
			}
		},
		swipeListFn(data) {
			this.newswipeList = data
		},
		// async getTrainlist() {
		// 	let params = {
		// 		pageSize: 5,
		// 		pageCurrent: 1,
		// 		pressSuperClass: 44,
		// 	};
		// 	let data = await httpService.getNewsList(params);
		// 	if (data.code == 200) {
		// 		this.trainData = data.result.list
		// 	}
		// },
		goNotice() {
			this.$router.push('/news-secondpage/notice');
		},
		// checknewsTab(item) {
		// 	this.activeNewName = item.name
		// 	if (this.activeNewName == '时政要闻') {
		// 		this.getNews(22)
		// 	} else {
		// 		this.getNews(1)
		// 	}
		// },
		checknewsTab2(item) {
			this.activeNewName2 = item.name
			if (this.activeNewName2 == '通知公告') {
				this.getNewsfn(16)
			} else if (this.activeNewName2 == '时政要闻') {
				this.getNewsfn(22)
			} else {
				// 行业动态
				// this.getconfereeListFn()
				this.getNewsfn(1)
			}
		},
		// 课程列表
		// async getCourseListFn() {
		// 	let params = {
		// 		pageSize: 6,
		// 		pageCurrent: 1,
		// 		auditResult: 5,
		// 	};
		// 	let data = await httpService.getCourseList(params);
		// 	if (data.code == 200) {
		// 		this.CourseData = data.result.list
		// 	}
		// },
		// 报名成功
		successApplyFn() {
			this.singupVisible = false;
			// this.getCourseListFn()
		},
		// 会议列表
		// async getconfereeListFn() {
		// 	let params = {
		// 		pageSize: 6,
		// 		pageCurrent: 1,
		// 		audit: 1
		// 	};
		// 	let data = await httpService.getconfereeList(params);
		// 	if (data.code == 200) {
		// 		this.confereeData = data.result.list
		// 	}
		// },
		// memberTitle: [
		// 	{ 'name': '会员风采', url: '/member-secondpage/member-style' },
		// ],
		// 更多
		// gosecondFn(item) {
		// 	let title = this.activeNewName
		// 	if (title == '时政要闻') {
		// 		this.$router.push('/news-secondpage/politics')
		// 	} else if (title == '行业动态') {
		// 		this.$router.push('/news-secondpage/industry-dynamics')
		// 	}
		// },
		gosecondFn1(item) {
			let title = this.activeNewName2
			if (title == '通知公告') {
				this.$router.push('/news-secondpage/notice')
			} else if (title == '时政要闻') {
				this.$router.push('/news-secondpage/politics')
			} else if (title == '行业动态') {
				this.$router.push('/news-secondpage/industry-dynamics')
			}
		},
		gosecondFn2() {
			this.$router.push('/member-secondpage/member-style')
		},
		goNewsDetailFn(val) {
			if (val.type == 2) {
				this.$router.push({
					path: "/meet-detail",
					query: {
						id: val.pressId,
						// type:val.type
					},
				});
			} else {
				this.$router.push({
					path: "/news-detail",
					query: {
						id: val.pressId,
						// type:val.type
					},
				});
			}
		},
		// 会议详情
		goconfereeDetailFn(val) {
			this.$router.push({
				path: "/meet-detail",
				query: {
					id: val.conferenceId,
				},
			});
		},
		changeSearchFn(item) {
			this.currentSearch = item.name
		},
		// 课程报名
		opencourseFn(val) {
			this.singupVisible = true
			this.currentCourse = val
		},
		// 先登录
		gologin() {
			this.$router.push('/login')
		},
		// 课程查询
		// submitForm(formName) {
		// 	this.$refs[formName].validate((valid) => {
		// 		if (valid) {
		// 			//    查询列表弹出弹框 无的话直接msg提示
		// 		} else {
		// 			return false;
		// 		}
		// 	});
		// },
		// 帮助中心
		gohelpFn() {
			this.$router.push('/help');
		},
		linkFn(data) {
			if (data.name == '申请入会') {
				if (this.token) {
					if (sessionStorage.getItem('audit') == 1) {
						this.$message({
							message: '您已经是会员账号',
							type: 'warning'
						});
					} else {
						this.$router.push(data.url);
						// this.$router.push('/account-center/centerpage')
					}
				} else {
					this.$message({
						message: '请先登录网站',
						type: 'warning'
					});
				}
			} else {
				this.$router.push(data.url);
				sessionStorage.setItem('clickMenu', data.name)
			}
		},
		changeSearch(name) {
			this.currentSearch = name
		},
		nameBlur(e) {
			this.nameVal = e.target.value
		},
		cardCodeBlur(e) {
			this.cardCodeVal = e.target.value
		},
		submitForm(formName) {
			// this.infoVisible = true
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let params = {
						pageCurrent: this.currentPage,
						pageSize: this.pageSize,
						...this.ruleForm
					}
					if (this.currentSearch == '报名信息查询') {
						httpService.findApply(params).then(res => {
							if (res.code == 200) {
								this.infoDataList = res.result.list
								this.total = res.result.total
								this.infoVisible = true
							} else {
								this.$message.error(res.message);
							}
						})
					} else {
						this.currentSearch = '成绩证书查询'
						httpService.findGrade(params).then(res => {
							if (res.code == 200) {
								this.certificateList = res.result.list
								this.certificatetotal = res.result.total
								this.infoVisible = true
							} else {
								this.$message.error(res.message);
							}
						})
					}
				} else {
					return false;
				}
			});
		},
		// 关闭表单
		offmodalFn() {
			this.infoVisible = false
			this.currentSearch = '报名信息查询'
		},
		dialogSearchFn(item) {
			this.currentSearch = item.name
			let params = {
				pageCurrent: this.currentPage,
				pageSize: this.pageSize,
				...this.ruleForm
			}
			if (this.currentSearch == '报名信息查询') {
				httpService.findApply(params).then(res => {
					if (res.code == 200) {
						this.infoDataList = res.result.list
						this.total = res.result.total
					} else {
						this.$message.error(res.message);
					}
				})
			} else {
				httpService.findGrade(params).then(res => {
					if (res.code == 200) {
						this.certificateList = res.result.list
						this.certificatetotal = res.result.total
					} else {
						this.$message.error(res.message);
					}
				})
			}
		},
		linkTarin(item) {
			sessionStorage.setItem('currentSearchName', item.name)
			this.$router.push(item.url);
			sessionStorage.setItem('clickMenu', '培训服务')
		}
	},
	filters: {
		timer: (value) => {
			if (value) {
				return value.substring(0, 10);
			}
		},
	},

};
</script>
<style scoped lang="less">
.containBox {
	width: 100%;
	position: relative;
}
.homewarp {
	width: 1220px;
	margin: 0 auto;
	// 联系我们
	.ContactUsbox {
		position: absolute;
		float: right;
		right: 60px;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		flex-direction: column;
		// 	align-content: center;
		// 	align-items: center;
		.contactusItem {
			display: flex;
			flex-direction: row;
			align-items: center;
			position: relative;
			.rightblockbox {
				display: flex;
				flex-direction: row;
				margin: 0 0 16px 10px;
				position: relative;
				&:hover {
					.leftnonebox {
						display: block;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						align-content: center;
					}
					.triangle {
						display: block;
					}
					.iconimg1 {
						background-image: url(../assets/imgs/home/sidebar/curIcon1.png);
					}
					.iconimg2 {
						background-image: url(../assets/imgs/home/sidebar/curIcon3.png);
					}
					.iconimg3 {
						background-image: url(../assets/imgs/home/sidebar/curIcon2.png);
					}
					.iconimg4 {
						background-image: url(../assets/imgs/home/sidebar/curIcon4.png);
					}
					.iconimg5 {
						background-image: url(../assets/imgs/home/sidebar/curIcon5.png);
					}
				}
				.iconbox {
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;
					.infobox2-4 {
						text-align: justify;
						letter-spacing: 5.3px;
						// margin-left: 20px;
					}
					img {
						margin-bottom: 10px;
					}
				}
				.triangle {
					position: absolute;
					right: 68px;
					bottom: 38%;
					width: 0px;
					height: 0px;
					border-left: 12px solid #f1f1f2;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					transform: translateY(-50%);
					display: none;
					// box-shadow: 0px 3px 22px rgba(0, 0, 0, 0.16);
				}
				.leftnonebox {
					position: absolute;
					right: 80px;
					top: 0px;
					padding: 20px 18px;
					width: 200px;
					background: #fff;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					align-content: center;
					box-shadow: 0px 3px 22px rgba(0, 0, 0, 0.16);
					// position: relative;
					margin-bottom: 20px;
					display: none;
					div {
						font-size: 16px;
						line-height: 30px;
						color: #666666;
					}
				}
				.imgbox {
					width: 54px;
					height: 54px;
					margin-bottom: 4px;
				}
				.iconimg1 {
					background-image: url(../assets/imgs/home/sidebar/icon1.png);
				}
				.iconimg2 {
					background-image: url(../assets/imgs/home/sidebar/icon3.png);
				}
				.iconimg3 {
					background-image: url(../assets/imgs/home/sidebar/icon2.png);
				}
				.iconimg4 {
					background-image: url(../assets/imgs/home/sidebar/icon4.png);
				}
				.iconimg5 {
					background-image: url(../assets/imgs/home/sidebar/icon5.png);
				}
			}

			// .infobox2 {
			// 	font-size: 18px;
			// 	line-height: 30px;
			// 	color: #333333;
			// }
			// .infobox3 {
			// 	font-size: 16px;
			// 	line-height: 30px;
			// 	color: #666666;
			// }
		}
	}
	.homecarouselBox {
		width: 1218px;
		margin: 20px 0;
		display: flex;
		flex-direction: row;
		position: relative;
		.carouselBox {
			width: 580px;
			margin-right: 30px;
			.titleBox {
				position: absolute;
				box-sizing: border-box;
				bottom: 0px;
				z-index: 99;
				padding: 0 0 0 20px;
				font-size: 18px;
				width: 580px;
				color: #fff;
				height: 47px;
				line-height: 47px;
				background: rgba(3, 9, 49, 0.49);
				border-radius: 0px 0px 0px 0px;
				.title {
					width: 420px;
				}
			}
			.el-carousel__item h3 {
				color: #475669;
				font-size: 16px;
				opacity: 0.75;
				line-height: 150px;
				margin: 0;
			}
			.el-carousel__item:nth-child(2n) {
				background-color: #99a9bf;
			}
			.el-carousel__item:nth-child(2n + 1) {
				background-color: #d3dce6;
			}
			/deep/.el-carousel__indicators--horizontal {
				left: 85%;
				transform: translateX(-50%);
			}
			/deep/.el-carousel__button {
				width: 6px;
				height: 6px;
				border-radius: 50%;
				display: inline;
			}
			img {
				width: 100%;
				height: 100%;
				cursor: pointer;
			}
		}
		.informBox {
			width: 612px;
			box-sizing: border-box;
			overflow: hidden;
			.inforDataBox {
				.inforItemBox {
					display: flex;
					flex-direction: row;
					margin-bottom: 28px;
					cursor: pointer;
					&:first-child {
						padding-top: 15px;
					}
					&:last-child {
						margin-bottom: 0;
					}
					.imgbox {
						width: 149px;
						height: 93px;
					}
					.msgbox {
						width: 68%;
						padding: 0 0 0 18px;
						text-align: left;
						.headlineBox {
							cursor: pointer;
							line-height: 28px;
							color: #666666;
							font-size: 16px;
							text-overflow: -o-ellipsis-lastline;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.time {
							line-height: 36px;
							color: #999999;
						}
					}
				}
			}
			.emptyBox {
				width: 100%;
			}
		}
		.leftMenuBox {
			width: 100%;
			display: flex;
			flex-direction: column;
			.jumpMenuBox {
				display: flex;
				flex-wrap: wrap;
				.menuImg {
					width: 297px;
					cursor: pointer;
					// &:nth-child(1n){
					// 	margin-right: 10px;
					// }
					margin-bottom: 16px;
					&:first-child,
					&:nth-child(3) {
						margin-right: 12px;
					}
				}
			}
		}
		.searchBox {
			width: 608px;
			margin-top: 6px;
			.line {
				display: inline-block;
				margin-top: 10px;
				width: 4px;
				height: 20px;
				background: #1875d9;
			}
			.name {
				font-size: 22px;
				font-weight: 500;
				color: #333333;
				display: inline-block;
				margin: 4px 0 0 16px;
			}
			.cardsearch {
				display: flex;
				flex-direction: row;
				margin-top: 22px;
				.itemBox {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					width: 296px;
					border: 1px solid #e7e7e7;
					height: 86px;
					&:first-child {
						margin-right: 12px;
						.imgbox {
							width: 40px;
							height: 43px;
						}
						.namebox {
							font-size: 18px;
							color: #333333;
							margin-left: 15px;
						}
					}
					.imgbox {
						width: 50px;
						height: 41px;
					}
					.namebox {
						font-size: 18px;
						color: #333333;
						margin-left: 12px;
					}
				}
			}
		}
	}
	.secondhomeNewsBox {
		width: 1218px;
		margin: 0;
		display: flex;
		flex-direction: row;
		height: 325px;
		box-sizing: border-box;
		.leftnewBox {
			width: 580px;
			margin-right: 30px;
			box-sizing: border-box;
			overflow: hidden;
			.emptyBox {
				width: 100%;
			}
		}
		.rightnewBox {
			width: 608px;
			.line {
				display: inline-block;
				margin-top: 10px;
				width: 4px;
				height: 20px;
				background: #1875d9;
			}
			.name {
				font-size: 22px;
				font-weight: 500;
				color: #333333;
				display: inline-block;
				margin: 4px 0 0 16px;
			}
			.groupCulture-box {
				width: 100%;
				display: flex;
				flex-direction: row;
				// flex-wrap: wrap;
				// margin-top: 60px;
				.business-imgbox {
					// width: 30%;
					width: 296px;
					height: 261px;
					box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.1);
					// height: 160px;
					cursor: pointer;
					margin: 13px 0px 0 0;
					padding: 14px;
					box-sizing: border-box;
					&:first-child {
						margin: 13px 16px 0 0;
					}
					&:hover {
						.title {
							color: #0083ff;
						}
					}
					&:nth-child(3n) {
						margin-right: 0;
					}
					img {
						width: 268px;
						height: 160px;
					}
					.title {
						margin-top: 12px;
					}
				}
			}
			.emptyBox {
				width: 100%;
			}
		}
	}
	.homeNewsBox {
		width: 1200px;
		margin: 60px auto 50px auto;
		.newstitleBox {
			display: flex;
			flex-direction: row;
			justify-content: center;
			font-size: 20px;
			// line-height: 35px;
			.namebox {
				color: #999999;
				cursor: pointer;
			}
			.activenamebox {
				color: #448df7;
				cursor: pointer;
			}
			.line {
				display: inline-block;
				margin: 0 45px;
				height: 16px;
				width: 1px;
				background: #c2c2c2;
			}
		}
		.activeNameBox {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			padding-bottom: 4px;
			border-bottom: 1px solid #52ca9c;
			margin-top: 30px;
			.name {
				width: 169px;
				height: 63px;
				background: #52ca9c;
				text-align: center;
				line-height: 63px;
				color: #ffffff;
				font-size: 20px;
			}
		}
		.newsDataBox {
			width: 100%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			margin-top: 10px;
			.newsItembox {
				width: 428px;
				margin-bottom: 30px;
				margin-right: 28px;
				cursor: pointer;
				&:nth-child(3n) {
					margin-right: 0;
				}
				.imgbox {
					width: 100%;
					height: 240px;
				}
				.contentbox:hover {
					box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
				}
				.contentbox {
					padding: 20px 15px 25px 15px;
					min-height: 124px;
					.title {
						font-size: 18px;
						font-weight: bold;
						line-height: 28px;
						color: #333;
					}
					.synopsis {
						line-height: 30px;
						font-size: 16px;
						color: #666666;
					}
					.time {
						color: #999999;
						padding-top: 15px;
					}
				}
			}
		}
	}
	// 行业服务
	.industryServiceBox {
		width: 1300px;
		margin: 0px auto 50px auto;
		.el-carousel__item h3 {
			color: #475669;
			font-size: 16px;
			opacity: 0.75;
			line-height: 200px;
			margin: 0;
		}

		.el-carousel__item:nth-child(2n) {
			background-color: #99a9bf;
		}

		.el-carousel__item:nth-child(2n + 1) {
			background-color: #d3dce6;
		}
	}
	// 会员服务
	.vipBox {
		width: 1200px;
		margin: 60px auto 50px auto;
		display: flex;
		flex-direction: row;
		.groupCulture-box {
			width: 100%;
			display: flex;
			flex-direction: row;
			// margin-top: 60px;
			.business-imgbox {
				width: 20%;
				height: 460px;
				position: relative;
				overflow: hidden;
				// padding: 0 10px;
				img {
					cursor: pointer;
					transition: all 2s;
				}
			}
			.handleDialog {
				position: absolute;
				color: #ffffff;
				background: rgba(0, 0, 0, 0.39);
				background: linear-gradient(360deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
				bottom: 0;
				right: 0;
				width: 100%;
				height: 60px;
				color: #fff;
				display: flex;
				flex-direction: column;
				pointer-events: none;
				transition: all 2s;
				overflow: hidden;
				z-index: 99;
				padding: 0 10px;
				box-sizing: border-box;
				.business-title {
					height: 60px;
					line-height: 60px;
					font-size: 18px;
					font-weight: bold;
					text-align: center;
					padding-left: 30px;
				}
				.godetail-box {
					height: 0;
					border-radius: 3px;
					// padding: 0px 32px;
					box-sizing: border-box;
					cursor: pointer;
					font-size: 16px;
					font-weight: 400;
					line-height: 30px;
				}
			}
			.business-imgbox:hover {
				width: 40%;
				.handleDialog {
					height: 60%;
				}
				img {
					transform: translateY(-15px);
				}
			}
		}
	}
	.trainimgBox {
		width: 1114px;
		margin: 0px auto 60px auto;
		img {
			width: 100%;
			height: 187px;
		}
	}
	.infoSearchBox {
		width: 100%;
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid #87b7eb;
		margin-top: 10px;
		// height: 336px;
		// border: 1px solid #dfdfdf;
		// margin: 0 auto;
		// padding: 10px 48px 0 48px;
		// box-sizing: border-box;
		// box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
		.searchTextBox {
			// width: 145px;
			display: flex;
			flex-direction: row;
			font-size: 20px;
			line-height: 28px;
			// margin: 20px 0 48px 0;
			height: 40px;
			line-height: 40px;
			.searchItem {
				color: #333333;
				cursor: pointer;
				padding: 0 16px;
			}
			.activesearchItem {
				cursor: pointer;
				color: #fff;
				background: #1875d9;
				padding: 0 16px;
			}
		}
		// .formwarp {
		// 	/deep/.el-form-item__label {
		// 		font-size: 16px;
		// 		font-weight: bold;
		// 		line-height: 30px;
		// 		color: #333333;
		// 	}
		// 	.submintBtn {
		// 		display: flex;
		// 		flex-direction: column;
		// 		align-items: center;
		// 		width: 50%;
		// 		margin: 0 auto;
		// 		text-align: center;
		// 		font-size: 16px;
		// 		margin-top: 40px;
		// 	}
		// }
	}
	.formwarp {
		margin-top: 18px;
		// width: 610px;
		height: 166px;
		background: #f9f9f9;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		padding: 30px 60px 26px 20px;
		box-sizing: border-box;
		border: 1px solid #e7e7e7;
		position: relative;
		.searchbtnBox {
			position: absolute;
			right: 61px;
			bottom: 32px;
			width: 84px;
			height: 40px;
			background: #d2d2d2;
			text-align: center;
			line-height: 40px;
			color: #fff;
			cursor: pointer;
		}
		.searchbtn {
			background: #1875d9;
		}
		/deep/.el-input__inner {
			border-radius: 0px;
		}
	}
	.trainBox {
		width: 1200px;
		margin: 74px auto 0 auto;
		.trainListBox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.trainItem {
				margin: 0 28px 30px 0;
				width: 428px;
				height: 325px;
				box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
				// background: url(../assets/imgs/tarin/bgimg1.png) no-repeat 100%;
				background: url(../assets/imgs/train/bgimg1.png) no-repeat 100% 100%;
				padding: 24px 35px 0 30px;
				box-sizing: border-box;
				&:nth-child(3n) {
					margin-right: 0;
				}
				.name {
					font-size: 22px;
					font-weight: bold;
					line-height: 35px;
					color: #448df7;
					position: relative;
					cursor: pointer;
					margin-bottom: 15px;
				}
				.name::before {
					content: '';
					position: absolute;
					width: 68px;
					height: 0px;
					border: 2px solid #448df7;
					opacity: 1;
					background: #448df7;
					left: 0%;
					// transform: translateX(-50%);
					top: 32px;
				}
				.courseinfobox {
					font-size: 16px;
					line-height: 30px;
					color: #666666;
					margin-bottom: 15px;
				}
				.deadlinebox {
					color: #f34a4a;
				}
				.immediatelyBtn,
				.coursdeadline,
				.registeredbox {
					width: 118px;
					height: 31px;
					line-height: 31px;
					color: #fff;
					margin: 0 auto;
					text-align: center;
					cursor: pointer;
				}
				.immediatelyBtn {
					background: #448df7;
					cursor: pointer;
				}
				.coursdeadline {
					background: #c0c0c0;
				}
				.registeredbox {
					background: #4ab344;
				}
			}
		}
	}
	// 空状态盒子
	.emptyBox {
		width: 1200px;
		margin: 0 auto;
		justify-content: center;
	}
}
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 0px 40px 0px 40px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: center;
		.text {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin-bottom: 18px;
		}
		/deep/.el-form-item__label {
			font-size: 16px;
			// font-weight: bold;
			line-height: 30px;
			color: #333333;
		}
		.submintBtn {
			width: 152px;
			height: 40px;
			background: #448df7;
			color: #fff;
			margin: 0 20px;
			cursor: pointer;
			font-size: 16px;
			text-align: center;
			line-height: 40px;
		}
		.datawarp {
			width: 100%;
			border-top: 1px solid #e8e8e8;
			.searchbox {
				display: flex;
				flex-direction: row;
				justify-content: center;
				font-size: 20px;
				line-height: 28px;
				margin: 20px 0 48px 0;
				.searchItem {
					color: #333333;
					cursor: pointer;
					margin: 0 30px;
				}
				.activesearchItem {
					cursor: pointer;
					color: #448df7;
					margin: 0 30px;
				}
			}
			.datalistBox {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				padding: 0 90px;
				.trainItem {
					margin: 0 20px 30px 0;
					width: 286px;
					height: 240px;
					box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
					// background: url(../assets/imgs/tarin/bgimg1.png) no-repeat 100%;
					background: url(../assets/imgs/train/bgimg1.png) no-repeat 100% 100%;
					padding: 20px 30px 0 25px;
					box-sizing: border-box;
					&:nth-child(3n) {
						margin-right: 0;
					}
					.name {
						font-size: 16px;
						font-weight: bold;
						line-height: 24px;
						color: #448df7;
						position: relative;
						cursor: pointer;
						margin-bottom: 15px;
					}
					// .name::before {
					// 	content: '';
					// 	position: absolute;
					// 	width: 68px;
					// 	height: 0px;
					// 	border: 2px solid #448df7;
					// 	opacity: 1;
					// 	background: #448df7;
					// 	left: 0%;
					// 	// transform: translateX(-50%);
					// 	top: 32px;
					// }
					.courseinfobox {
						font-size: 14px;
						line-height: 30px;
						color: #666666;
						margin-bottom: 15px;
					}
					.deadlinebox {
						color: #c0c0c0;
					}
					// .immediatelyBtn,
					// .coursdeadline,
					// .registeredbox {
					// 	width: 118px;
					// 	height: 31px;
					// 	line-height: 31px;
					// 	color: #fff;
					// 	margin: 0 auto;
					// 	text-align: center;
					// }
					// .immediatelyBtn {
					// 	background: #448df7;
					// 	cursor: pointer;
					// }
					// .coursdeadline {
					// 	background: #c0c0c0;
					// }
					.registeredbox {
						width: 118px;
						height: 31px;
						line-height: 31px;
						color: #fff;
						margin: 0 auto;
						text-align: center;
						background: #c0c0c0;
						// cursor: not-allowed;
					}
				}
			}
			.pdfdatabox {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				// justify-content: center;
				.pdfItem {
					width: 510px;
					height: 244px;
					background: #fff;
					box-shadow: 0px 3px 22px rgba(204, 213, 220, 0.76);
					border-radius: 12px;
					margin: 0 30px 30px 0px;
					padding: 16px;
					box-sizing: border-box;
					&:nth-child(2n) {
						margin-right: 0;
					}
					.pdftop {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: center;
						font-size: 16px;
						line-height: 24px;
						color: #333333;
						margin-bottom: 20px;
						.certificateName {
							margin-right: 20px;
						}
					}
					.pdfbotbox {
						display: flex;
						flex-direction: row;
						.downbox {
							width: 106px;
							height: 141px;
							background: rgba(94, 206, 255, 0.39);
							position: relative;
							cursor: pointer;
							img {
								width: 64px;
								height: 80px;
								margin: 30px 20px 0 20px;
							}
							.downicon {
								position: absolute;
								bottom: 0px;
								left: 0px;
								font-size: 20px;
								color: #fff;
								width: 0;
								height: 0;
								border-bottom: 50px solid #8f8f8f;
								border-right: 50px solid transparent;
								cursor: pointer;
								.icon {
									margin: 27px 0px 0px 4px;
								}
							}
						}
						.courseinfobox {
							margin-left: 16px;
							width: 260px;
							.name {
								font-size: 16px;
								font-weight: bold;
								line-height: 24px;
								color: #333333;
							}
							.infotext {
								font-size: 14px;
								line-height: 30px;
								color: #8f8f8f;
							}
							.score {
								font-size: 18px;
								line-height: 24px;
								color: #0e83fc;
							}
						}
					}
				}
			}
			.searchempty {
				width: 100%;
				text-align: center;
				img {
					width: 193px;
					height: 155px;
				}
			}
		}
		// .formBtnBox {
		// 	display: flex;
		// 	fill-opacity: row;
		// 	justify-content: center;
		// 	cursor: pointer;
		// 	margin-top: 70px;
		// 	.submitBtn {
		// 		width: 152px;
		// 		height: 40px;
		// 		background: #349cff;
		// 		margin: 0 20px;
		// 		cursor: pointer;
		// 	}
		// }
	}
}
</style>
